import { render, staticRenderFns } from "./NavigationCatalog.vue?vue&type=template&id=2cae532d&scoped=true"
import script from "./NavigationCatalog.vue?vue&type=script&lang=js"
export * from "./NavigationCatalog.vue?vue&type=script&lang=js"
import style0 from "./NavigationCatalog.vue?vue&type=style&index=0&id=2cae532d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae532d",
  null
  
)

export default component.exports